import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg width="28" height="27" viewBox="0 0 28 27" xmlns="http://www.w3.org/2000/svg" {...this.props}><g fill="none" fillRule="evenodd"><path d="M15.811.577a1.896 1.896 0 0 0-2.733.01L6.606 7.252c-1.839 1.844.92 4.612 2.76 2.767l2.239-2.253c.51-.513.923-.347.923.375v9.582c0 1.08.875 1.955 1.95 1.955a1.952 1.952 0 0 0 1.952-1.955V8.142c0-.72.413-.888.922-.375l2.239 2.253c1.84 1.845 4.598-.923 2.759-2.767L15.811.577z" fill="#4EB7F5" /><path d="M3 24.75h22.5M2.167 24.7v-6.2M26.167 24.7v-6.2" stroke="#4EB7F5" strokeWidth="3.5" strokeLinecap="round" /></g></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/static/images/sources/upload.svg